import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const VEHICLES_ON_SITE_REPORT = 'VehiclesOnSite';
export const VEHICLES_ON_SITE_REPORT_TITLE = 'Vehicles on Site';
export const VEHICLES_ON_SITE_REPORT_INFO = 'Displays the Vehicles On Site report for the date range provided';
export const VEHICLES_ON_SITE_REPORT_SHEET_TITLE = 'Vehicles on site (v01)';

export const columns: ReportColumnConfig[] = [
  { name: 'repairerName', title: 'Repairer Name', width: '150' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'regMark', title: 'Vehicle Reg.' },
  { name: 'claimID', title: 'Claim ID' },
  { name: 'claimReference', title: 'Claim Ref.', width: '150' },
  { name: 'localStatus', title: 'Local Status' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'model', title: 'Model' },
  { name: 'dtgCreated', title: 'Date Created', type: 'date' },
  { name: 'dtgBookedIn', title: 'Date Booked In', type: 'date' },
  { name: 'dtgOnSite', title: 'On Site Date', type: 'date' },
  { name: 'courtesyMake', title: 'Courtesy Make' },
  { name: 'replacementReg', title: 'Replacement Reg.' },
];
